import React, { Component } from 'react';
import {
  FormGroup,
  ControlLabel,
  FormControl,
  Row,
  Col,
  Alert
} from 'react-bootstrap';
import Loader             from "../../Loader";
import { MEMBER_TOKEN }     from "actions/const";
import debounce           from "lodash.debounce";

class Create extends Component {
  constructor (props) {
    super(props);

    this.delayCallback = debounce(props.checkForExistingMember, 1000);
  }
  render () {
    const {
      MemberToken,
      actions
    } = this.props;

    const {
      isLoadingAction,

      form_memberId,
      form_cardType,

      memberId_isChecking,
      memberId_isExisting
    } = MemberToken;

    let requiredSpan = <span style={{ color: "red" }}>*</span>;

    return (
      <form>
        <Loader loading={isLoadingAction}/>
        <Row>
          <Col md={6}>
            <FormGroup>
              <ControlLabel>Member ID {requiredSpan} {memberId_isChecking ? <i className="fa fa-spinner fa-spin"/> : ''}</ControlLabel>
              <FormControl
                  placeholder="Enter Member ID..."
                  value={form_memberId}
                  onChange={(e) => {
                      actions.setValue(
                        MEMBER_TOKEN,
                        {
                          form_memberId: e.target.value
                        }
                      );

                      this.delayCallback(e.target.value);
                  }}
              />
            </FormGroup>
            {memberId_isExisting &&
            <Alert bsStyle='danger'>
              Member ID already exists.
            </Alert>}
          </Col>
          <Col md={6}>
            <FormGroup>
              <ControlLabel>Card Type</ControlLabel>
              <FormControl
                  placeholder="Enter Card Type..."
                  value={form_cardType}
                  onChange={(e) => {
                      actions.setValue(
                        MEMBER_TOKEN,
                        {
                          form_cardType: e.target.value
                        }
                      );
                  }}
              />
            </FormGroup>
          </Col>
        </Row>
      </form>
    );
  }
}

export default Create;


// WEBPACK FOOTER //
// ./components/Home/FormContainer/Create.js